import React from 'react';
import { DraggableModal } from '@ui/shared/components/Common/DraggableModal';
import SessionLog from '../SessionDetails/SessionLog';
import { getStore, useAppStore } from '../../stores/StoreContext';
import { useFullScreenMountNode } from '../../contexts/FullScreenContext';
import { useHotkeys } from 'react-hotkeys-hook';
import CONSTANTS from '../../config/constants';

/**
 * SessionLogModal component
 * Displays a draggable modal containing the session log with all events and annotations
 * 
 * @component
 * @example
 * return (
 *   <SessionLogModal />
 * )
 */
function SessionLogModal() {
    const AppStore = getStore('appStore');
    const isOpen = useAppStore((state) => state.isSessionLogModalOpen);
    const mountNode = useFullScreenMountNode();

    const handleClose = () => {
        AppStore.closeSessionLog();
    };

    // Register keyboard shortcut for opening session log
    useHotkeys(CONSTANTS?.KEYBOARD_SHORTCUTS?.VIEW?.OPTIONS?.SESSION_LOG?.KEY, () => AppStore.openSessionLog(), {
        preventDefault: true
    });

    return (
        <DraggableModal
            isOpen={isOpen}
            onClose={handleClose}
            title="Session Log"
            initialSize={{ width: '50vw', height: '50vh' }}
            initialPosition="bottom right"
            resizable={true}
            minimizable={true}
            minSize={{ width: 400, height: 300 }}
            maxSize={{ width: 1000, height: 2000 }}
            constrainToContainer={false}
            id="session-log-modal"
            mountNode={mountNode}
            contentStyle={{
                padding: '0'
            }}
        >
            <SessionLog />
        </DraggableModal>
    );
}

export default SessionLogModal;
